import { Button } from "@/components/ui/button";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { useGetShippingRecipientHistoryQuery } from "@/services/shipping-recipient";
import { SECTOR_EMAILS_LABELS } from "../messages";
import { RecipientHistoryEntry, SectorRecipient } from "../types";

interface RecipientHistoryModalProps {
  recipient: SectorRecipient;
}

const formatChangedAt = (value: string): string => {
  const date: Date = new Date(value);
  return `${date.toLocaleDateString("pt-BR")} às ${date.toLocaleTimeString(
    "pt-BR",
    { hour: "2-digit", minute: "2-digit" }
  )}`;
};

export function RecipientHistoryModal({
  recipient,
}: RecipientHistoryModalProps): JSX.Element {
  const { handleModal } = useDialogModal();
  const { data } = useGetShippingRecipientHistoryQuery(recipient.id);
  const entries: readonly RecipientHistoryEntry[] = data ?? [];

  return (
    <div className="w-full max-w-md space-y-4">
      <div>
        <p className="font-medium text-gray-900">{recipient.name}</p>
        <p className="text-xs text-gray-500">{recipient.email}</p>
      </div>

      {entries.length === 0 && (
        <p className="text-sm text-muted-foreground">
          {SECTOR_EMAILS_LABELS.HISTORY_EMPTY}
        </p>
      )}

      <ol className="space-y-3 border-l-2 border-gray-200 pl-4">
        {entries.map((entry: RecipientHistoryEntry) => (
          <li key={entry.id} className="space-y-0.5">
            <p className="text-sm text-gray-900">{entry.description}</p>
            <p className="text-xs text-gray-500">
              {formatChangedAt(entry.changed_at)} · {entry.changed_by}
            </p>
          </li>
        ))}
      </ol>

      <div className="flex justify-end">
        <Button
          variant="outline"
          onClick={() => handleModal({ isOpen: false })}
        >
          Fechar
        </Button>
      </div>
    </div>
  );
}
